import Events from "../Events";
import { sendGTMGA4Event } from "../TagManagerGa4";

export const nativeEvents = (events: Events) => {
  events.addEventListener(
    "begin_checkout",
    ({ transaction_id, item_id, item_name, price }) => {
      sendGTMGA4Event(null); // limpar parametros do ecommerce

      sendGTMGA4Event({
        event: "begin_checkout",
        ecommerce: {
          currency: "BRL",
          value: price,
          items: [{ item_id, item_name, price }],
        },
      });
    }
  );

  events.addEventListener(
    "add_payment_info",
    ({ transaction_id, ecommerce, value }) => {
      sendGTMGA4Event(null); // limpar parametros do ecommerce
      sendGTMGA4Event({
        event: "add_payment_info",
        ecommerce: {
          currency: "BRL",
          value: value,
          payment_type: "Credit Card",
          items: [ecommerce],
        },
      });
    }
  );

  events.addEventListener(
    "purchase",
    ({ transaction_id, ecommerce, value }) => {
      sendGTMGA4Event(null); // limpar parametros do ecommerce
      console.log(transaction_id);
      sendGTMGA4Event({
        event: "purchase",
        ecommerce: {
          currency: "BRL",
          value: value,
          transaction_id,
          items: [ecommerce],
        },
      });
      
      sendGTMGA4Event({
        event: "purchase_custom",
        ecommerce: {
          currency: "BRL",
          value: value,
          transaction_id,
          items: [ecommerce],
        },
      });
    }
  );

  return events;
};
